import React, { useState, useEffect } from "react";
import gymImage from "../images/1.png";
import backgroundImage from "../images/section4back.png";
import { FaArrowAltCircleDown } from "react-icons/fa";
import { FiPhoneCall } from "react-icons/fi";
import { SlCalender } from "react-icons/sl";
import { MdOutlineDirections } from "react-icons/md";

const locations = [
  {
    id: 1,
    name: "Stonehousepet, Nellore",
    phone: "9989777909",
    timings: {
      weekdays: "Mon-Sat : 5:30 am to 9:00 pm",
      sunday: "Sunday :   Holiday",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/C5SPzkhY932Qw3WL6",
  },
  {
    id: 2,
    name: "Harinathpuram, Nellore",
    phone: "9247040404",
    timings: {
      weekdays: "Mon-Sat : 5:30 am to 9:00 pm",
      sunday: "Sun : 5.30 am to 10:00 am",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/hqoVD3fn4HXuiHCp6",
  },
  {
    id: 3,
    name: "Vanamthopu Center, Nellore",
    phone: "7799890404",
    timings: {
      weekdays: "Mon-Sat : 5:30 am to 9:00 pm",
      sunday: "Sun : 5.30 am to 10:00 am",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/xUBX5hMjasRuF7rW6",
  },
  {
    id: 4,
    name: "Current Office Center, Nellore",
    phone: "9640620404",
    timings: {
      weekdays: "Mon-Sat : 5:00 am to 10:00 pm",
      sunday: "Sun : 7:00 am to 8:00 pm",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/Qi2vojxhpoUe1q376",
  },
  {
    id: 5,
    name: "Vedayapalem, Nellore",
    phone: "7799710404",
    timings: {
      weekdays: "Mon-Sat : 5:00 am to 10:00 pm",
      sunday: "Sun : 7:00 am to 8:00 pm",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/yHJRQg2vXvPRFnX97",
  },
  {
    id: 6,
    name: "BV Nagar, Nellore",
    phone: "7799720404",
    timings: {
      weekdays: "Mon-Sat : 5:00 am to 10:00 pm",
      sunday: "Sun : 7:00 am to 8:00 pm",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/mJHS7BpYowHNVy9S9",
  },
  {
    id: 7,
    name: "Dhanalakshmi Puram, Nellore",
    phone: "9707434579",
    timings: {
      weekdays: "Mon-Sat : 5:00 am to 10:00 pm",
      sunday: "Sun : 7:00 am to 8:00 pm",
    },
    image: gymImage,
    mapsLink: "https://maps.app.goo.gl/Dd5MuLumCJ8W5J9y8",
  }
];


const styles = {
  section: {
    backgroundColor: "#1E1E1E",
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    color: "white",
    padding: "80px 20px",
    textAlign: "center",
    minHeight: 0, // Let height be determined by content
    overflow: "hidden",
    fontFamily: "inter, sans-serif",
  },
  title: {
    fontSize: "3rem",
    fontWeight: "bold",
    marginBottom: "2rem",
    color: "white",
  },
  highlight: {
    color: "#54B73D",
  },
  subtitle: {
    marginBottom: "3rem",
    color: "#9ca3af",
    fontSize: "1.1rem",
  },
  cardsContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "2rem",
    flexWrap: "wrap",
    marginBottom: "3rem",
  },
  card: {
    backgroundColor: "#3D3D3D",
    borderRadius: "0.5rem",
    overflow: "hidden",
    maxWidth: "350px",
    textAlign: "left",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
  },
  cardImage: {
    width: "100%",
    height: "160px",
    objectFit: "cover",
    display: 'block',
  },
  cardContent: {
    padding: "1.5rem",
    paddingTop: "0.5rem",
  },
  cardTitle: {
    fontWeight: "bold",
    marginBottom: "1.5rem",
    fontSize: "1.3rem",
    textAlign: "center",
  },
  infoRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: "1.1rem", // Improved vertical spacing
  },
  infoText: {
    fontSize: "1rem",
    marginLeft: "0.5rem",
    color: "#d1d5db",
  },
  button: {
    backgroundColor: "#54B73D",
    color: "black",
    width: "100%",
    padding: "0.75rem",
    borderRadius: "10px",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "0.5rem",
    border: "none",
    cursor: "pointer",
    fontSize: "1rem",
    marginTop: "20px",
    transition: 'background 0.2s, color 0.2s, box-shadow 0.2s',
  },
  viewAllButton: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.75rem 1.5rem",
    border: "2px solid white",
    borderRadius: "9999px",
    backgroundColor: "transparent",
    color: "white",
    cursor: "pointer",
    fontSize: "1rem",
    margin: "32px auto 0 auto", // More space above, centered
  },
};

export default function ChooseTrainingZone() {
  const [activeCardIndex, setActiveCardIndex] = useState(1); // Start with middle card (index 1) active
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [windowWidth, setWindowWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);
  const [autoScrollEnabled, setAutoScrollEnabled] = useState(true);

  // Window resize handler
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Auto-scroll functionality for mobile and medium mobile views
  useEffect(() => {
    if (!autoScrollEnabled || windowWidth > 767) return;

    const interval = setInterval(() => {
      setActiveCardIndex((prev) => (prev + 1) % locations.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [autoScrollEnabled, windowWidth]);

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setAutoScrollEnabled(false); // Stop auto-scroll on user interaction
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (windowWidth <= 767) {
      // For mobile and medium mobile screens, loop through all locations
      if (isLeftSwipe) {
        // Swipe left: move to next card
        setActiveCardIndex((prev) => (prev + 1) % locations.length);
      }
      if (isRightSwipe) {
        // Swipe right: move to previous card
        setActiveCardIndex((prev) => (prev - 1 + locations.length) % locations.length);
      }
    } else {
      // For larger screens, only show first 3 cards
      if (isLeftSwipe) {
        setActiveCardIndex((prev) => (prev + 1) % 3);
      }
      if (isRightSwipe) {
        setActiveCardIndex((prev) => (prev - 1 + 3) % 3);
      }
    }
  };

  // Mouse events for desktop testing
  const onMouseDown = (e) => {
    setAutoScrollEnabled(false); // Stop auto-scroll on user interaction
    setTouchEnd(null);
    setTouchStart(e.clientX);
  };

  const onMouseMove = (e) => {
    if (touchStart !== null) {
      setTouchEnd(e.clientX);
    }
  };

  const onMouseUp = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (windowWidth <= 767) {
      // For mobile and medium mobile screens, loop through all locations
      if (isLeftSwipe) {
        setActiveCardIndex((prev) => (prev + 1) % locations.length);
      }
      if (isRightSwipe) {
        setActiveCardIndex((prev) => (prev - 1 + locations.length) % locations.length);
      }
    } else {
      // For larger screens, only show first 3 cards
      if (isLeftSwipe) {
        setActiveCardIndex((prev) => (prev + 1) % 3);
      }
      if (isRightSwipe) {
        setActiveCardIndex((prev) => (prev - 1 + 3) % 3);
      }
    }
    
    setTouchStart(null);
    setTouchEnd(null);
  };

  const getCardClassName = (index) => {
    let className = 'card-mobile';
    
    if (windowWidth <= 767) {
      // For mobile and medium mobile screens, show carousel effect with all cards
      const position = (index - activeCardIndex + locations.length) % locations.length;
      
      if (position === 0) {
        className += ' center-card';
      } else if (position === 1 || position === locations.length - 1) {
        // Show previous and next cards as side cards
        className += position === 1 ? ' right-card' : ' left-card';
      } else {
        className += ' hidden-card';
      }
    } else {
      // For larger screens, use original 3-card coverflow
      const position = (index - activeCardIndex + 3) % 3;
      
      if (position === 0) {
        className += ' center-card';
      } else if (position === 1) {
        className += ' right-card';
      } else {
        className += ' left-card';
      }
    }
    
    return className;
  };

  const handleDotClick = (index) => {
    setAutoScrollEnabled(false); // Stop auto-scroll on user interaction
    setActiveCardIndex(index);
  };

  return (
    <>
      <style>
        {`
          /* Shine effect for cards */
          .card-mobile, .card {
            position: relative;
            overflow: hidden;
            cursor: default;
          }
          .card-mobile::before, .card::before {
            content: '';
            position: absolute;
            top: 0;
            left: -75%;
            width: 50%;
            height: 100%;
            background: linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 50%, rgba(255,255,255,0) 100%);
            transform: skewX(-20deg);
            transition: none;
            pointer-events: none;
          }
          .card-mobile:hover, .card:hover {
            cursor: pointer;
          }
          .card-mobile:hover::before, .card:hover::before {
            left: 120%;
            transition: left 1.2s cubic-bezier(0.4,0,0.2,1);
          }
          .direction-button:hover {
            background-color: #16a34a;
            transform: translateY(-2px);
          }

          .custom-button {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #333;
            border: 2px solid #fff;
            border-radius: 50px;
            padding: 10px 20px;
            color: #fff;
            font-size: 16px;
            cursor: pointer;
            box-shadow: 4px 4px 0 #000;
            margin: 0 auto;
          }

          .button-text {
            margin-right: 20px;
          }

          .button-icon {
            width: 35px;
            height: 35px;
          }

          .button-icon img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }

          @media (max-width: 480px) {
            /* Mobile title styling */
            .mobile-title {
              font-size: 1.2rem !important;
              font-weight: 700 !important;
              margin-bottom: 1rem !important;
              color: white !important;
              font-family: 'Poppins', sans-serif !important;
              line-height: 1.2 !important;
              text-align: center !important;
            }

            .mobile-title .highlight {
              color: #54B73D !important;
              font-weight: 800 !important;
            }

            /* Mobile subtitle styling */
            .mobile-subtitle {
              margin-bottom: 2rem !important;
              color: #9ca3af !important;
              font-size: 0.6rem !important;
              font-family: 'Poppins', sans-serif !important;
              font-weight: 400 !important;
              line-height: 1.4 !important;
              text-align: center !important;
              padding: 0 10px !important;
            }

            /* Mobile swipe indicator styling */
            .swipe-indicator {
              font-size: 0.7rem !important;
              font-family: 'Poppins', sans-serif !important;
              font-weight: 300 !important;
              color: #6b7280 !important;
              text-align: center !important;
              margin: 1rem 0 !important;
              opacity: 0.8 !important;
            }

            .cards-container-mobile {
              display: flex !important;
              flex-direction: row !important;
              justify-content: center !important;
              align-items: center !important;
              width: 100% !important;
              position: relative !important;
              height: 320px !important;
              overflow: visible !important;
              touch-action: pan-y !important;
              perspective: 1000px !important;
              margin: 0 auto !important;
            }

            /* Base card styling for coverflow */
            .card-mobile {
              background: #3D3D3D !important;
              cursor: pointer !important;
              transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
              position: absolute !important;
              flex: none !important;
              margin: 0 !important;
              max-width: none !important;
              min-width: 0 !important;
              border-radius: 12px !important;
              transform-style: preserve-3d !important;
            }

            /* Center card - main focus */
            .card-mobile.center-card {
              width: 220px !important;
              height: 260px !important;
              left: 50% !important;
              top: 20px !important;
              transform: translateX(-50%) translateZ(0) rotateY(0deg) scale(1) !important;
              z-index: 10 !important;
              opacity: 1 !important;
              filter: blur(0px) !important;
            }

            /* Left card - rotated and scaled down */
            .card-mobile.left-card {
              width: 180px !important;
              height: 200px !important;
              left: 15% !important;
              top: 40px !important;
              transform: translateX(-50%) translateZ(-150px) rotateY(25deg) scale(0.85) !important;
              z-index: 5 !important;
              opacity: 0.7 !important;
              filter: blur(1px) !important;
            }

            /* Right card - rotated and scaled down */
            .card-mobile.right-card {
              width: 180px !important;
              height: 200px !important;
              right: 15% !important;
              left: auto !important;
              top: 40px !important;
              transform: translateX(50%) translateZ(-150px) rotateY(-25deg) scale(0.85) !important;
              z-index: 5 !important;
              opacity: 0.7 !important;
              filter: blur(1px) !important;
            }

            /* Hidden cards for mobile carousel */
            .card-mobile.hidden-card {
              opacity: 0 !important;
              transform: translateX(-50%) translateZ(-300px) scale(0.5) !important;
              z-index: 1 !important;
              pointer-events: none !important;
            }

            /* Center card content styling */
            .card-mobile.center-card img {
              width: 100% !important;
              height: 90px !important;
              border-top-left-radius: 12px !important;
              border-top-right-radius: 12px !important;
              object-fit: cover !important;
            }

            .card-mobile.center-card .card-content {
              padding: 15px 20px !important;
            }

            .card-mobile.center-card .card-title {
              font-size: 12px !important;
              margin-bottom: 15px !important;
              margin-top: 8px !important;
              font-weight: 600 !important;
            }

            .card-mobile.center-card .info-text {
              font-size: 10px !important;
              margin-left: 10px !important;
            }

            .card-mobile.center-card .infoRow {
              margin-bottom: 12px !important;
            }

            .card-mobile.center-card .infoRow svg {
              width: 10px !important;
              height: 10px !important;
            }

            .card-mobile.center-card .button {
              height: 28px !important;
              font-size: 10px !important;
              margin-top: 15px !important;
              border-radius: 8px !important;
            }

            /* Side cards content styling */
            .card-mobile.left-card img,
            .card-mobile.right-card img {
              width: 100% !important;
              height: 75px !important;
              border-top-left-radius: 12px !important;
              border-top-right-radius: 12px !important;
              object-fit: cover !important;
            }

            .card-mobile.left-card .card-content,
            .card-mobile.right-card .card-content {
              padding: 12px 15px !important;
            }

            .card-mobile.left-card .card-title,
            .card-mobile.right-card .card-title {
              font-size: 10px !important;
              margin-bottom: 10px !important;
              margin-top: 6px !important;
              font-weight: 500 !important;
            }

            .card-mobile.left-card .info-text,
            .card-mobile.right-card .info-text {
              font-size: 8px !important;
              margin-left: 8px !important;
            }

            .card-mobile.left-card .infoRow,
            .card-mobile.right-card .infoRow {
              margin-bottom: 8px !important;
            }

            .card-mobile.left-card .infoRow svg,
            .card-mobile.right-card .infoRow svg {
              width: 8px !important;
              height: 8px !important;
            }

            .card-mobile.left-card .button,
            .card-mobile.right-card .button {
              height: 22px !important;
              font-size: 8px !important;
              margin-top: 10px !important;
              border-radius: 6px !important;
            }

            /* Custom styling for MdOutlineDirections icon in mobile */
            .card-mobile .direction-button svg {
              width: 12px !important;
              height: 12px !important;
              margin-left: 4px !important;
            }

            .card-mobile.center-card .direction-button svg {
              width: 20px !important;
              height: 20px !important;
              margin-left: 6px !important;
            }

            .card-mobile.left-card .direction-button svg,
            .card-mobile.right-card .direction-button svg {
              width: 10px !important;
              height: 10px !important;
              margin-left: 3px !important;
            }

            /* Mobile View All Locations Button */
            .custom-button {
              padding: 8px 15px !important;
              font-size: 12px !important;
              border-radius: 30px !important;
              font-family: 'Poppins', sans-serif !important;
              font-weight: 500 !important;
              margin-top: 20px !important;
              box-shadow: 3px 3px 0 #000 !important;
              transition: all 0.3s ease !important;
            }

            /* Mobile Slider Dots */
            .slider-dots {
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              gap: 8px !important;
              margin-top: 20px !important;
              margin-bottom: 15px !important;
            }

            .slider-dot {
              width: 8px !important;
              height: 8px !important;
              border-radius: 50% !important;
              background-color: rgba(255, 255, 255, 0.3) !important;
              transition: all 0.3s ease !important;
              cursor: pointer !important;
            }

            .slider-dot.active {
              background-color: #54B73D !important;
              width: 12px !important;
              height: 12px !important;
              box-shadow: 0 0 8px rgba(84, 183, 61, 0.5) !important;
            }

            .slider-dot:hover {
              background-color: rgba(255, 255, 255, 0.6) !important;
              transform: scale(1.1) !important;
            }

            .slider-dot.active:hover {
              background-color: #54B73D !important;
            }

            .custom-button:hover {
              background-color: black !important;
              transform: translateY(-1px) !important;
              box-shadow: 2px 2px 0 #000 !important;
            }

            .button-text {
              margin-right: 12px !important;
              font-size: 12px !important;
            }

            .button-icon {
              width: 22px !important;
              height: 22px !important;
            }

            .direction-button.button {
              transition: background 0.25s cubic-bezier(0.4,0,0.2,1),
                          color 0.25s cubic-bezier(0.4,0,0.2,1),
                          box-shadow 0.25s cubic-bezier(0.4,0,0.2,1),
                          transform 0.25s cubic-bezier(0.4,0,0.2,1);
            }
            .direction-button.button:hover {
              background-color:rgb(197, 158, 32) !important;
              color: #222 !important;
              box-shadow: 0 6px 24px 0 rgba(84,183,61,0.12), 0 1.5px 6px 0 rgba(0,0,0,0.08);
              /* No movement, only content zoom */
            }
          }

          @media (min-width: 481px) and (max-width: 767px) {
            /* Medium Mobile title styling */
            .mobile-title {
              font-size: 1.8rem !important;
              font-weight: 700 !important;
              margin-bottom: 1.5rem !important;
              color: white !important;
              font-family: 'Poppins', sans-serif !important;
              line-height: 1.2 !important;
              text-align: center !important;
            }

            .mobile-title .highlight {
              color: #54B73D !important;
              font-weight: 800 !important;
            }

            /* Medium Mobile subtitle styling */
            .mobile-subtitle {
              margin-bottom: 2.5rem !important;
              color: #9ca3af !important;
              font-size: 0.9rem !important;
              font-family: 'Poppins', sans-serif !important;
              font-weight: 400 !important;
              line-height: 1.4 !important;
              text-align: center !important;
              padding: 0 20px !important;
            }

            .cards-container-mobile {
              display: flex !important;
              flex-direction: row !important;
              justify-content: center !important;
              align-items: center !important;
              width: 100% !important;
              position: relative !important;
              height: 400px !important;
              overflow: visible !important;
              touch-action: pan-y !important;
              perspective: 1000px !important;
              margin: 0 auto !important;
            }

            /* Base card styling for medium mobile coverflow */
            .card-mobile {
              background: #3D3D3D !important;
              cursor: pointer !important;
              transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1) !important;
              position: absolute !important;
              flex: none !important;
              margin: 0 !important;
              max-width: none !important;
              min-width: 0 !important;
              border-radius: 16px !important;
              transform-style: preserve-3d !important;
            }

            /* Medium Mobile Center card - main focus */
            .card-mobile.center-card {
              width: 280px !important;
              height: 340px !important;
              left: 50% !important;
              top: 30px !important;
              transform: translateX(-50%) translateZ(0) rotateY(0deg) scale(1) !important;
              z-index: 10 !important;
              opacity: 1 !important;
              filter: blur(0px) !important;
            }

            /* Medium Mobile Left card - rotated and scaled down */
            .card-mobile.left-card {
              width: 240px !important;
              height: 280px !important;
              left: 12% !important;
              top: 60px !important;
              transform: translateX(-50%) translateZ(-150px) rotateY(20deg) scale(0.88) !important;
              z-index: 5 !important;
              opacity: 0.8 !important;
              filter: blur(0.5px) !important;
            }

            /* Medium Mobile Right card - rotated and scaled down */
            .card-mobile.right-card {
              width: 240px !important;
              height: 280px !important;
              right: 12% !important;
              left: auto !important;
              top: 60px !important;
              transform: translateX(50%) translateZ(-150px) rotateY(-20deg) scale(0.88) !important;
              z-index: 5 !important;
              opacity: 0.8 !important;
              filter: blur(0.5px) !important;
            }

            /* Medium Mobile Center card content styling */
            .card-mobile.center-card img {
              width: 100% !important;
              height: 120px !important;
              border-top-left-radius: 16px !important;
              border-top-right-radius: 16px !important;
              object-fit: cover !important;
            }

            .card-mobile.center-card .card-content {
              padding: 20px 24px !important;
            }

            .card-mobile.center-card .card-title {
              font-size: 16px !important;
              margin-bottom: 18px !important;
              margin-top: 10px !important;
              font-weight: 600 !important;
            }

            .card-mobile.center-card .info-text {
              font-size: 13px !important;
              margin-left: 12px !important;
            }

            .card-mobile.center-card .infoRow {
              margin-bottom: 14px !important;
            }

            .card-mobile.center-card .infoRow svg {
              width: 14px !important;
              height: 14px !important;
            }

            .card-mobile.center-card .button {
              height: 36px !important;
              font-size: 13px !important;
              margin-top: 18px !important;
              border-radius: 10px !important;
            }

            /* Medium Mobile Side cards content styling */
            .card-mobile.left-card img,
            .card-mobile.right-card img {
              width: 100% !important;
              height: 100px !important;
              border-top-left-radius: 16px !important;
              border-top-right-radius: 16px !important;
              object-fit: cover !important;
            }

            .card-mobile.left-card .card-content,
            .card-mobile.right-card .card-content {
              padding: 16px 20px !important;
            }

            .card-mobile.left-card .card-title,
            .card-mobile.right-card .card-title {
              font-size: 13px !important;
              margin-bottom: 14px !important;
              margin-top: 8px !important;
              font-weight: 600 !important;
            }

            .card-mobile.left-card .info-text,
            .card-mobile.right-card .info-text {
              font-size: 11px !important;
              margin-left: 10px !important;
            }

            .card-mobile.left-card .infoRow,
            .card-mobile.right-card .infoRow {
              margin-bottom: 10px !important;
            }

            .card-mobile.left-card .infoRow svg,
            .card-mobile.right-card .infoRow svg {
              width: 11px !important;
              height: 11px !important;
            }

            .card-mobile.left-card .button,
            .card-mobile.right-card .button {
              height: 28px !important;
              font-size: 10px !important;
              margin-top: 12px !important;
              border-radius: 8px !important;
            }

            /* Medium Mobile Direction button icons */
            .card-mobile .direction-button svg {
              width: 16px !important;
              height: 16px !important;
              margin-left: 6px !important;
            }

            .card-mobile.center-card .direction-button svg {
              width: 18px !important;
              height: 18px !important;
              margin-left: 8px !important;
            }

            .card-mobile.left-card .direction-button svg,
            .card-mobile.right-card .direction-button svg {
              width: 12px !important;
              height: 12px !important;
              margin-left: 4px !important;
            }

            /* Medium Mobile Slider Dots */
            .slider-dots {
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              gap: 10px !important;
              margin-top: 25px !important;
              margin-bottom: 20px !important;
            }

            .slider-dot {
              width: 10px !important;
              height: 10px !important;
              border-radius: 50% !important;
              background-color: rgba(255, 255, 255, 0.3) !important;
              transition: all 0.3s ease !important;
              cursor: pointer !important;
            }

            .slider-dot.active {
              background-color: #54B73D !important;
              width: 14px !important;
              height: 14px !important;
              box-shadow: 0 0 10px rgba(84, 183, 61, 0.6) !important;
            }

            .custom-button {
              padding: 10px 18px !important;
              font-size: 14px !important;
              border-radius: 35px !important;
              font-family: 'Poppins', sans-serif !important;
              font-weight: 500 !important;
              margin-top: 25px !important;
              box-shadow: 4px 4px 0 #000 !important;
              transition: all 0.3s ease !important;
            }

            .button-text {
              margin-right: 15px !important;
              font-size: 14px !important;
            }

            .button-icon {
              width: 28px !important;
              height: 28px !important;
            }
          }
          .all-locations-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
            gap: 2rem;
            margin: 2.5rem auto 0 auto;
            max-width: 1200px;
          }
          .all-locations-grid .card {
            position: relative;
            margin: 0;
            min-width: 0;
          }
        `}
      </style>

<section style={styles.section}>
  <h2 style={styles.title} className="mobile-title">
    Choose Your <span style={styles.highlight} className="highlight">Training Zone</span>
  </h2>
  <p style={styles.subtitle} className="mobile-subtitle">
    Discover the Future Fitness center closest to you and crush your goals today.
  </p>

  <div 
    style={styles.cardsContainer} 
    className="cards-container-mobile"
    onTouchStart={onTouchStart}
    onTouchMove={onTouchMove}
    onTouchEnd={onTouchEnd}
    onMouseDown={onMouseDown}
    onMouseMove={onMouseMove}
    onMouseUp={onMouseUp}
    onMouseLeave={onMouseUp}
  >
    {(windowWidth <= 767 ? locations : locations.slice(0, 4)).map((location, index) => (
      <div 
        key={location.id} 
        style={styles.card} 
        className={getCardClassName(index)}
      >
        <img src={location.image} alt={location.name} style={styles.cardImage} />
        <div style={styles.cardContent} className="card-content">
          <h3 style={styles.cardTitle} className="card-title">
            {location.name}
          </h3>
          <div style={styles.infoRow} className="infoRow">
            <FiPhoneCall />
            <span style={styles.infoText} className="info-text">
              {location.phone}
            </span>
          </div>
          <div style={styles.infoRow} className="infoRow">
            <SlCalender />
            <span style={styles.infoText} className="info-text">
              {location.timings.weekdays}
            </span>
          </div>
          <div style={styles.infoRow} className="infoRow">
            <SlCalender />
            <span style={styles.infoText} className="info-text">
              Sunday: {location.timings.sunday.replace(/(Sunday|Sun)\s*:? /i, '')}
            </span>
          </div>
          <button
            style={styles.button}
            className="direction-button button"
            onClick={() => window.open(location.mapsLink, '_blank')}
          >
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center' }}>
              Get Directions <MdOutlineDirections />
            </span>
          </button>
        </div>
      </div>
    ))}
  </div>

  <div className="slider-dots">
    {(windowWidth <= 767 ? locations : locations.slice(0, 4)).map((_, index) => (
      <div
        key={index}
        className={`slider-dot ${activeCardIndex === index ? 'active' : ''}`}
        onClick={() => handleDotClick(index)}
      />
    ))}
  </div>

  {!showAll && windowWidth > 767 && (
    <button
      className="custom-button"
      style={{ marginTop: '32px', display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: 'auto' }}
      onClick={() => setShowAll(true)}
    >
      <span className="button-text">View All Locations</span>
      <span className="button-icon">
        <FaArrowAltCircleDown style={{ fontSize: '2rem', color: '#54B73D' }} />
      </span>
    </button>
  )}

  {showAll && windowWidth > 767 && (
    <div className="all-locations-grid">
      {locations.slice(4).map((location, index) => (
        <div key={location.id} style={styles.card} className="card">
          <img src={location.image} alt={location.name} style={styles.cardImage} />
          <div style={styles.cardContent} className="card-content">
            <h3 style={styles.cardTitle} className="card-title">
              {location.name}
            </h3>
            <div style={styles.infoRow} className="infoRow">
              <FiPhoneCall />
              <span style={styles.infoText} className="info-text">
                {location.phone}
              </span>
            </div>
            <div style={styles.infoRow} className="infoRow">
              <SlCalender />
              <span style={styles.infoText} className="info-text">
                {location.timings.weekdays}
              </span>
            </div>
            <div style={styles.infoRow} className="infoRow">
              <SlCalender />
              <span style={styles.infoText} className="info-text">
                Sunday: {location.timings.sunday.replace(/(Sunday|Sun)\s*:? /i, '')}
              </span>
            </div>
            <button
              style={styles.button}
              className="direction-button button"
              onClick={() => window.open(location.mapsLink, '_blank')}
            >
              <span style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', width: '100%', justifyContent: 'center' }}>
                Get Directions <MdOutlineDirections />
              </span>
            </button>
          </div>
        </div>
      ))}
    </div>
  )}
</section>

    </>
  );
}
